import FormErrors from "@/components/FormErrors/FormErrors";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import uuidv4 from "uuid/v4";
import { JSConn } from "@/utilities/js-conn";

export default {
  name: "lineItemEditForm",
  components: {
    FormErrors,
    LoadingAnimation,
  },
  props: {
    lineItemId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Line Item...",
      hasFormErrors: false,
      cancelParams: { name: "lineItems" },
      formErrors: [],
      lineItem: {
        description: null,
        default_rate: 0,
        status: "active",
      },
    };
  },
  created() {
    if (this.lineItemId === "new") {
      this.lineItem = {
        id: uuidv4(),
        description: "New",
        default_rate: 10.25,
        status: "active",
      };
      this.dataLoaded = true;
      this.$nextTick(() => this.$refs.firstInput.select());
    } else {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: this.lineItemId,
      };

      this.$store.dispatch("needLineItem", jsConn).then(() => {
        // correct line item is in the store
        this.lineItem = {
          description: this.apiLineItem.description,
          status: this.apiLineItem.status,
          default_rate: this.apiLineItem.default_rate,
          id: this.apiLineItem.id,
        };
        this.dataLoaded = true;
        this.cancelParams = {
          name: "lineItems",
        };
        this.$nextTick(() => this.$refs.firstInput.select());
      });
    }
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();
      jsConn.formParams = this.lineItem;
      jsConn.toRoutePath = "/line-items";

      let storeDispatch;

      if (this.lineItemId === "new") {
        storeDispatch = "createLineItem";
      } else {
        storeDispatch = "updateLineItem";
      }

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(jsConn => {
          this.$router.push(jsConn.toRoutePath);
          return Promise.resolve(jsConn);
        })
        .catch(jsConn => {
          this.hasFormErrors = true;
          this.formErrors = jsConn.error["response"]["data"];
        });
    },
    showDeleteModal() {
      this.$refs["deleteModal"].show();
    },
    hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },
    deleteLineItem() {
      const jsConn = new JSConn();
      jsConn.toRoutePath = "/line-items";
      jsConn.formParams = {
        id: this.lineItemId,
      };
      this.$store.dispatch("deleteLineItem", jsConn).then(jsConn => {
        this.$router.push(jsConn.toRoutePath);
        return Promise.resolve(jsConn);
      });
    },
  },
  computed: {
    apiLineItem: function() {
      return this.$store.getters.lineItem;
    },
  },
};
